import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from './ui/card';
import { MapPin, Building2, Calendar } from 'lucide-react';

export const ProjectCard = ({ project }) => {
  return (
    <Card className="project-card hover:shadow-lg transition-all duration-300 overflow-hidden">
      {project.image && (
        <div className="w-full h-48 overflow-hidden">
          <img 
            src={project.image} 
            alt={project.title}
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
          />
        </div>
      )}
      <CardHeader>
        <div className="flex items-start justify-between mb-2">
          <CardTitle className="text-lg font-semibold text-slate-800">{project.title}</CardTitle>
          <span className="text-xs font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded">
            {project.year}
          </span>
        </div>
        <CardDescription className="text-slate-600">
          {project.description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="flex items-center text-sm text-slate-600">
            <MapPin className="w-4 h-4 mr-2 text-blue-600" />
            {project.location}
          </div>
          <div className="flex items-center text-sm text-slate-600">
            <Building2 className="w-4 h-4 mr-2 text-blue-600" />
            {project.type}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
